import { AccountOwnerField } from '../../../services/account-list.service'
import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import {
  AccountListBellConfiguration,
  AccountOwners,
} from '../omega-timestamp-status-bar.model'

/**
 * @internal
 */
export type AccountOwnerFieldOption =
  | 'Managers'
  | 'Ops Managers'
  | 'Reconcilers'
const accountOwnerFieldToOption = new Map<
  AccountOwnerField,
  AccountOwnerFieldOption
>([
  ['manager', 'Managers'],
  ['opsManager', 'Ops Managers'],
  ['reconciler', 'Reconcilers'],
])

const accountOwnerOptionToField = new Map<
  AccountOwnerFieldOption,
  AccountOwnerField
>([
  ['Managers', 'manager'],
  ['Ops Managers', 'opsManager'],
  ['Reconcilers', 'reconciler'],
])

@Component({
  selector: 'hs-configure-bell-modal',
  templateUrl: './configure-bell-modal.component.html',
  styleUrls: [],
})
export class ConfigureBellModalComponent {
  readonly accountOwnerFieldOptions: AccountOwnerFieldOption[] = [
    'Managers',
    'Ops Managers',
    'Reconcilers',
  ]

  accountOwnerField?: AccountOwnerFieldOption
  accountOwners?: AccountOwners
  userNameChoices: string[] = []
  selectedUserNames?: string[]
  selectUserNamesLabel = 'Users'
  hasInitialized = false

  constructor(readonly activeModal: NgbActiveModal) {}

  init(
    owners: AccountOwners,
    accountOwnerField: AccountOwnerField,
    userNames: string[],
  ) {
    this.accountOwners = owners
    this.accountOwnerField = accountOwnerFieldToOption.get(accountOwnerField)
    this.selectedUserNames = userNames
    this.userNameChoices = this.getUserNameChoices(
      this.accountOwnerField,
      this.accountOwners,
    )
    this.selectUserNamesLabel = this.accountOwnerField ?? 'Users'
    this.hasInitialized = true
  }

  onAccountOwnerFieldChange(option: AccountOwnerFieldOption) {
    this.selectedUserNames = []
    this.selectUserNamesLabel = option
    if (this.accountOwners == null) {
      this.userNameChoices = []
      return
    }

    this.userNameChoices = this.getUserNameChoices(option, this.accountOwners)
  }

  private getUserNameChoices(
    option: AccountOwnerFieldOption | undefined,
    owners: AccountOwners,
  ): string[] {
    switch (option) {
      case 'Managers':
        return owners.managers
      case 'Ops Managers':
        return owners.opsManagers
      case 'Reconcilers':
        return owners.reconcilers
      default:
        return []
    }
  }

  submit() {
    if (!this.hasInitialized || this.accountOwnerField == null) {
      return
    }

    const field = accountOwnerOptionToField.get(this.accountOwnerField)
    if (field == null) {
      return
    }

    this.activeModal.close({
      userNames: this.selectedUserNames,
      accountOwnerField: field,
    } as AccountListBellConfiguration)
  }
}
